function datalayer_event() {
    const elements = document.querySelectorAll(".datalayer-element");
    if (!elements.length) {
        return;
    }

    elements.forEach((element) => {
        element.addEventListener("click", () => {
            window.dataLayer.push({
                event: "customEvent",
                GAeventCategory: "event_informational_action",
                GAeventAction: element.dataset.datalayerAction,
                GAeventLabel: element.dataset.actionDetail,
            });
        });
    });
}

datalayer_event();
